<template>
    <div class="chat-group">
        <div class="group-header">
            <div class="agent-info">
                <AgentAvatar
                    :key="group.id"
                    :size="40"
                    :font-size="14"
                    :userID="group.id"
                    v-if="group.id"
                />
                <h2 class="agent-name">{{ getAgentName(group.id) }}</h2>
            </div>
            <div class="group-stats">
                <div class="stat-item">
                    <i class="material-icons">person</i>
                    <span class="stat-label">{{ $t("chatWindow.totalCustomer") }}</span>
                    <span class="stat-value">{{ groupStats.totalCustomers }}</span>
                </div>
                <div class="stat-item">
                    <i class="material-icons">description</i>
                    <span class="stat-label">{{ $t("chatWindow.unanswered") }}</span>
                    <span class="stat-value">{{ groupStats.unanswered }}</span>
                </div>
                <div class="stat-item">
                    <i class="material-icons">check_circle</i>
                    <span class="stat-label">{{ $t("chatWindow.answered") }}</span>
                    <span class="stat-value">{{ groupStats.answered }}</span>
                </div>
            </div>
            <button class="watch-all-btn" @click="handleWatchAll">
                <i class="material-icons">visibility</i>
                <span>{{ $t("message.watchAllLive") }}</span>
            </button>
        </div>
        <div class="customers">
            <CustomerCard
                v-for="item in group.items"
                :key="item.name"
                :item="item"
                :group-id="group.id"
                :agent-name="getAgentName(group.id)"
                :selected-item-id="selectedItemId"
                @select="handleCustomerSelect"
            />
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import AgentAvatar from "../../common/AgentAvatar.vue";
import CustomerCard from "./CustomerCard.vue";

export default Vue.extend({
    name: "ChatGroup",
    components: {
        AgentAvatar,
        CustomerCard,
    },
    props: {
        group: {
            type: Object,
            required: true,
        },
        selectedItemId: {
            type: String,
            required: true,
        },
        users: {
            type: Object,
            required: true,
        },
    },
    computed: {
        groupStats() {
            return {
                totalCustomers: this.group.items.length,
                answered: this.group.items.filter((item) => {
                    const answerStatus = item.answerStatus || item.lastConversation?.answerStatus;
                    return answerStatus === "answered";
                }).length,
                unanswered: this.group.items.filter((item) => {
                    const answerStatus = item.answerStatus || item.lastConversation?.answerStatus;
                    return answerStatus !== "answered";
                }).length,
                autoAssignLimit: this.users[this.group.id]?.autoAssignLimit || 0,
            };
        },
    },
    methods: {
        getAgentName(agentId) {
            if (agentId === "chatbot") return "Chatbot";
            if (agentId === "unassign") return "Sahipsiz";
            return this.users[agentId]?.name || "-";
        },
        handleWatchAll() {
            this.$emit("watch-all", this.group.id);
        },
        handleCustomerSelect(index) {
            this.$emit("select-customer", index);
        },
    },
});
</script>

<style scoped lang="scss">
.chat-group {
    margin-bottom: 24px !important;
    background: #f9fafb;
    padding: 10px;
    border-radius: 20px;

    .group-header {
        display: flex !important;
        align-items: center !important;
        justify-content: space-between !important;
        padding: 16px 20px !important;
        background: #f9fafb !important;
        border-radius: 12px !important;
        margin-bottom: 16px !important;
        gap: 16px !important;
        box-sizing: border-box !important;

        .agent-info {
            display: flex !important;
            align-items: center !important;
            gap: 12px !important;
            flex-shrink: 0 !important;

            .agent-name {
                font-size: 18px !important;
                font-weight: 600 !important;
                color: #111827 !important;
                margin: 0 !important;
                line-height: 1 !important;
            }
        }

        .group-stats {
            display: flex !important;
            align-items: center !important;
            gap: 20px !important;
            flex: 1 !important;

            .stat-item {
                display: flex !important;
                align-items: center !important;
                gap: 6px !important;
                border: none !important;

                .material-icons {
                    font-size: 20px !important;
                    color: #6b7280 !important;
                }

                .stat-label {
                    font-size: 14px !important;
                    font-weight: 500 !important;
                    color: #6b7280 !important;
                    white-space: nowrap !important;
                }

                .stat-value {
                    font-size: 16px !important;
                    font-weight: 700 !important;
                    color: #111827 !important;
                }
            }
        }

        .watch-all-btn {
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            gap: 8px !important;
            height: 40px !important;
            padding: 0 16px !important;
            background: #ffffff !important;
            border: 1px solid #e5e7eb !important;
            border-radius: 12px !important;
            font-size: 14px !important;
            font-weight: 500 !important;
            color: #374151 !important;
            cursor: pointer !important;
            transition: all 0.2s ease !important;
            flex-shrink: 0 !important;
            white-space: nowrap !important;

            .material-icons {
                font-size: 20px !important;
                color: inherit !important;
            }

            &:hover {
                background: #f9fafb !important;
                border-color: #d1d5db !important;
            }

            &:active {
                background: #f3f4f6 !important;
            }
        }
    }

    .customers {
        display: flex !important;
        flex-wrap: wrap !important;
        gap: 12px !important;
    }
}
</style>
